import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20.09 16.094"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#4EBC73" }, [
      _createElementVNode("path", { d: "M17.496 7.817h-6.23a.75.75 0 0 1 0-1.5h6.23a.75.75 0 0 1 0 1.5m.75 2.21a.75.75 0 0 0-.75-.75h-6.23a.75.75 0 0 0 0 1.5h6.23a.76.76 0 0 0 .75-.77zM5.376 8.497a1.2 1.2 0 1 0 .02-2.4 1.2 1.2 0 0 0-.02 2.4" }),
      _createElementVNode("path", { d: "M19.716 1.687a3 3 0 0 0-1.31-1.31 7.4 7.4 0 0 0-3.16-.33h-10.4a7.4 7.4 0 0 0-3.16.33 3 3 0 0 0-1.32 1.31 7.6 7.6 0 0 0-.32 3.16v6.4a7.6 7.6 0 0 0 .32 3.16 2.94 2.94 0 0 0 1.32 1.31 7.4 7.4 0 0 0 3.16.33h10.4a7.4 7.4 0 0 0 3.16-.33 3 3 0 0 0 1.31-1.31c.245-1.102.356-2.23.33-3.36v-6.23a7.4 7.4 0 0 0-.33-3.13m-14.26 10.13a3.72 3.72 0 1 1 3.72-3.72 3.73 3.73 0 0 1-3.72 3.72m12-1h-6.19a.75.75 0 0 1 0-1.5h6.23a.75.75 0 0 1 0 1.5zm0-3h-6.19a.75.75 0 0 1 0-1.5h6.23a.75.75 0 0 1 0 1.5z" }),
      _createElementVNode("path", { d: "M6.276 8.817h-1.65a1.39 1.39 0 0 0-1.38 1.38v.07q.256.25.56.44a3.19 3.19 0 0 0 3.3 0q.3-.187.55-.44v-.07a1.38 1.38 0 0 0-1.38-1.38" })
    ], -1)
  ]))]))
}
export default { render: render }